import { useCallback, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _pick from 'lodash/pick';
import { VALIDATE_MESSAGES } from '../consts';

export default () => {
  const [isShowError, setIsShowError] = useState(false);
  const [submitTime, setSubmitTime] = useState(null);
  const [errors, setErrors] = useState({});

  const validateFields = useCallback((prepareFormValues = {}) => {
    const emptyFields = Object.entries(prepareFormValues)
      .filter(([, value]) => _isEmpty(value))
      .map(([key]) => key);
    const fieldErrors = _pick(VALIDATE_MESSAGES, emptyFields);

    const isSomeValueEmpty = emptyFields.length > 0;

    if (isSomeValueEmpty) {
      setIsShowError(true);
      setErrors(fieldErrors);
      setSubmitTime(Date.now());

      return true;
    }

    setErrors({});
    setIsShowError(false);
    setSubmitTime(null);

    return false;
  }, []);

  return { isShowError, submitTime, errors, validateFields, setIsShowError };
};
